export const IMPORT_VCARD_AIDE = {
  intro:
    'Sur iPhone, OcéRM importe les contacts via un fichier .vcf / .vcard. Deux façons de l’obtenir :',
  iphoneTitre: 'Depuis l’iPhone',
  iphoneEtapes: 'Contacts → ouvre une fiche →',
  iphonePartager: 'Partager le contact',
  iphoneEnregistrer: 'Enregistrer dans Fichiers',
  iphoneFin: 'puis importe-la ici.',
  plusieursTitre: 'Plusieurs contacts',
  plusieursDebut: 'dans',
  mac: 'Contacts sur Mac',
  plusieursEtapes: 'sélectionne les fiches → Fichier → Exporter →',
  exporterVcard: 'Exporter vCard',
  icloudIntro: 'Tu peux aussi passer par',
  icloud: 'iCloud.com',
  icloudEtapes: '→ Contacts → tout sélectionner →',
} as const;
